import styles from "./Form.module.css";
import cn from "classnames";
import { ReactNode } from "react";
import { forwardRef } from "react";

type Size = "S" | "M" | "L";

interface Props extends React.FormHTMLAttributes<HTMLFormElement> {
  size: Size;
  children: ReactNode;
  onSubmit?: () => void;
}

export const Form = forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { size, children, className, ...nativeProps } = props;

  const onSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (props.onSubmit) {
      props.onSubmit();
    }
  };

  return (
    <form
      onSubmit={props.onSubmit ? (event) => onSubmit(event) : undefined}
      className={cn(styles.form, styles[`size-${size}`], className)}
      ref={ref}
      {...nativeProps}
    >
      {children}
    </form>
  );
});
